import { canUpdate } from './validators/functions/can-update.function';

export * from './dtos/proto-settings.dto';
export * from './dtos/update-proto-settings.dto';

export const protoSettingsValidators = { canUpdate };
